export default __webpack_public_path__ + "static/media/regis.f31e4d55.svg";